import { type CheckboxGroupState } from '@react-stately/checkbox';
import { createContext, useContext } from 'react';

import { type CheckboxProps } from '../checkbox/Checkbox';
import { type CheckboxGroupProps } from './CheckboxGroup';

export interface CheckboxGroupContextValue {
  state: CheckboxGroupState | null;
  color: CheckboxProps['color'];
  size?: CheckboxProps['size'];
  iconPosition?: CheckboxProps['iconPosition'];
  alignIcon?: CheckboxProps['alignIcon'];
  orientation?: CheckboxGroupProps['orientation'];
}

export const CheckboxGroupContext = createContext<CheckboxGroupContextValue>({
  state: null,
  color: 'primary',
  size: 'md',
  iconPosition: 'left',
  alignIcon: 'start',
  orientation: 'vertical',
});

export const useCheckboxGroupContext = () => useContext(CheckboxGroupContext);
